import { Status, StatusProps } from '@insight-health-ai/roseate/components';
import { Appointment, AppointmentChatCompletionStatus } from 'src/models';

const statusConfigMap: Record<
  Lowercase<AppointmentChatCompletionStatus>,
  {
    appearance?: StatusProps['appearance'];
    label: string;
    style?: StatusProps['style'];
  }
> = {
  completed: { appearance: 'success', label: 'Completed' },
  processed: { label: 'Processed', style: { color: '#4d38ca' } },
  inprogress: { appearance: 'warning', label: 'In Progress' },
  partial_completed: { appearance: 'warning', label: 'Partial Summary' },
  new: { appearance: 'info', label: 'Not Started' },
  unavailable: { label: 'Aura Encounter', style: { color: '#018749' } },
};

type AppointmentIntakeStatusProps = {
  status: Appointment['chat_completion_status'];
  statusProps?: StatusProps;
};

export const AppointmentIntakeStatus = ({
  status,
  statusProps,
}: AppointmentIntakeStatusProps) => {
  const key =
    status?.toLowerCase() as Lowercase<AppointmentChatCompletionStatus>;
  const config = statusConfigMap[key];

  return (
    <Status
      size="sm"
      {...statusProps}
      style={config?.style}
      appearance={config?.appearance || 'neutral'}
      label={config?.label || status || 'Unknown'}
    />
  );
};
